import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import FrontPage from '../components/FrontPage.vue'
import Listings from '../components/Listings.vue'
import AuctionPage from '../components/AuctionPage.vue'
import RegisterToBidPage from '../components/RegisterToBidPage.vue'
import RegisterToBidInviteBuyer from '../components/RegisterToBidInviteBuyer.vue'
import Login from '../components/Login.vue'
import CognitoOAuthAuthorizeCallback from '../components/CognitoOAuthAuthorizeCallback.vue'
import CognitoLogoutCallback from '../components/CognitoLogoutCallback.vue'
import DashboardPage from '../components/DashboardPage.vue'
import BiddersPage from '../components/BiddersPage.vue'
import AuctionClosingFlow from '../components/AuctionClosingFlow.vue'
import CreateListingPage from '../components/CreateListingPage.vue'
import CreateDelegatePage from '../components/CreateDelegatePage.vue'
import TenantProfile from '../components/TenantProfile.vue'
import TenantMembers from '../components/TenantMembers.vue'
import TenantAssistant from '../components/TenantAssistant.vue'
import TenantCustomize from '../components/TenantCustomize.vue'
import TenantActivate from '../components/TenantActivate.vue'
import ProfilePage from '../components/ProfilePage.vue'
import ProfilePagePreferences from '../components/ProfilePagePreferences.vue'
import ApplicationStatus from '../components/ApplicationStatus.vue'
import ApplicationStatusForListingAgent from '../components/ApplicationStatusForListingAgent.vue'
import AuctionWinnerPage from '../components/AuctionWinnerPage.vue'
import JoinPage from '../components/JoinPage.vue'
import JoinAuctionPage from '../components/JoinAuctionPage.vue'
import AuditTrailPage from '../components/AuditTrailPage.vue'
import StaticContentPage from '../components/StaticContentPage.vue'
import SessionExpired from '../components/SessionExpired.vue'
import PfxAdminTenants from '../components/PfxAdminTenants.vue'
import PfxAdminViewTenant from '../components/PfxAdminViewTenant.vue'
import PfxAdminApplications from '../components/PfxAdminApplications.vue'
import PfxAdminApplication from '../components/PfxAdminApplication.vue'
import PfxAdminUsers from '../components/PfxAdminUsers.vue'
import PfxAdminViewUser from '../components/PfxAdminViewUser.vue'
import FaqAgents from '../components/FaqAgents.vue'
import FaqBuyers from '../components/FaqBuyers.vue'
import FaqSellers from '../components/FaqSellers.vue'
import AboutBrokers from '../components/AboutBrokers.vue'
import AboutBuyers from '../components/AboutBuyers.vue'
import AboutSellers from '../components/AboutSellers.vue'
import AboutPFX from '../components/AboutPFX.vue'
import Privacy from '../components/Privacy.vue'
import Terms from '../components/Terms.vue'
import Broker from '../components/Broker.vue'
import InactiveTenantPage from '../components/InactiveTenantPage.vue'
import { isUserProfileIncomplete, isCompanyProfileIncomplete } from '../utils/PfxUtils.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      component: FrontPage,
      meta: {
        header: 'dark',
        activeTenantRequired: true
      }
    },
    {
      path: '/session-expired',
      component: SessionExpired
    },
    {
      path: '/listings',
      component: Listings,
      meta: {
        header: 'dark',
        activeTenantRequired: true
      }
    },
    {
      path: '/auction/:auctionId',
      component: AuctionPage,
      meta: {
        header: 'dark',
        activeTenantRequired: true
      }
    },
    {
      path: '/auction/:auctionId/register',
      component: RegisterToBidPage,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/auction/:auctionId/register/invite/buyer',
      component: RegisterToBidInviteBuyer,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/sign-in-required',
      component: Login,
      meta: {
        view: 'login'
      }
    },
    {
      path: '/login',
      component: Login,
      meta: {
        view: 'login'
      }
    },
    {
      path: '/signup/token/:token?',
      component: Login,
      meta: {
        view: 'secret',
        activeTenantRequired: true
      }
    },
    {
      path: '/join/:token?',
      component: JoinPage,
      meta: {
        activeTenantRequired: true
      }
    },
    {
      path: '/join/auction/:token?',
      component: JoinAuctionPage,
      meta: {
        activeTenantRequired: true
      }
    },
    {
      path: '/cognito/oauth/authorize/callback',
      component: CognitoOAuthAuthorizeCallback,
      meta: {
        noHeader: true,
        noFooter: true
      }
    },
    {
      path: '/cognito/logout/callback',
      component: CognitoLogoutCallback,
      meta: {
        noHeader: true,
        noFooter: true
      }
    },
    {
      path: '/dashboard',
      component: DashboardPage,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/dashboard/create/:auctionId?',
      component: CreateListingPage,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/dashboard/bidders/:auctionId',
      component: BiddersPage,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/dashboard/delegate/:auctionId?',
      component: CreateDelegatePage,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/registration-form/:auctionId/:applicationId',
      component: ApplicationStatusForListingAgent,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/application/:auctionId/:applicationId',
      component: ApplicationStatus,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/closing/:auctionId',
      component: AuctionClosingFlow,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/winner/:auctionId/:applicationId',
      component: AuctionWinnerPage,
      meta: {
        authRequired: true,
        activeTenantRequired: true
      }
    },
    {
      path: '/company/members/:action?',
      component: TenantMembers,
      meta: {
        authRequired: true,
        adminRequired: true
      }
    },
    {
      path: '/company/assistant/:action?',
      component: TenantAssistant,
      meta: {
        authRequired: true,
        adminRequired: true
      }
    },
    {
      path: '/company/profile',
      component: TenantProfile,
      meta: {
        authRequired: true,
        adminRequired: true
      }
    },
    {
      path: '/company/customize',
      component: TenantCustomize,
      meta: {
        authRequired: true,
        adminRequired: true
      }
    },
    {
      path: '/company/activate',
      component: TenantActivate,
      meta: {
        authRequired: true,
        adminRequired: true
      }
    },
    {
      path: '/profile',
      component: ProfilePage,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/profile/preferences',
      component: ProfilePagePreferences,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/privacy',
      component: Privacy,
      meta: {
        content: 'privacy'
      }
    },
    {
      path: '/terms',
      component: Terms,
      meta: {
        content: 'terms'
      }
    },
    {
      path: '/broker',
      component: Broker,
      meta: {
        content: 'broker'
      }
    },
    {
      path: '/inactive',
      component: InactiveTenantPage
    },
    {
      path: '/suspended',
      component: StaticContentPage,
      meta: {
        content: 'suspended'
      }
    },
    {
      path: '/deleted',
      component: StaticContentPage,
      meta: {
        content: 'deleted'
      }
    },
    {
      path: '/faq',
      redirect: '/faq/agents'
    },
    {
      path: '/faq/agents',
      component: FaqAgents,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/faq/buyers',
      component: FaqBuyers,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/faq/sellers',
      component: FaqSellers,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/about/for-brokers',
      component: AboutBrokers,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/about/for-buyers',
      component: AboutBuyers,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/about/for-sellers',
      component: AboutSellers,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/about',
      component: AboutPFX,
      meta: {
        header: 'dark'
      }
    },
    {
      path: '/pfxadmin/audit/:type/:id',
      component: AuditTrailPage,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '/pfxadmin/tenants',
      component: PfxAdminTenants,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '/pfxadmin/tenants/:subdomain',
      component: PfxAdminViewTenant,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '/pfxadmin/applications',
      component: PfxAdminApplications,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '/pfxadmin/applications/:id',
      component: PfxAdminApplication,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '/pfxadmin/users',
      component: PfxAdminUsers,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '/pfxadmin/users/:userId',
      component: PfxAdminViewUser,
      meta: {
        authRequired: true,
        pfxAdminRequired: true
      }
    },
    {
      path: '*',
      component: StaticContentPage,
      meta: {
        content: 'notfound'
      }
    }
  ]
})

router.beforeResolve((to, from, next) => {
  isAuthRequired(to, from, next)
})

function isAuthRequired(to, from, next) {
  if (store.state.authenticatedUser === undefined || store.state.authenticatedUser === null ||
    store.state.tenant.status === undefined || store.state.tenant.status === null) {
    // initial authentication or tenant profile fetching are not yet done => wait and retry...
    setTimeout(() => { isAuthRequired(to, from, next) }, 200)
    return
  }

  if (to.path !== '/suspended' && store.state.tenant.status === 'SUSPENDED') {
    next('/suspended')
    return
  }

  if (to.path !== '/deleted' && store.state.tenant.status === 'DELETED') {
    next('/deleted')
    return
  }

  if (to.path !== '/inactive' && to.meta.activeTenantRequired === true && store.state.tenant.status !== 'ACTIVE') {
    next('/inactive')
    return
  }

  if (store.state.authenticatedUser === true) { // user is logged in, ok to access
    if (to.meta.pfxAdminRequired && store.state.user.pfxAdmin !== true) {
      next('/profile') // redirect to elsewhere
      return
    }
    if (to.meta.adminRequired && store.state.user.role !== 'ADMIN') {
      next('/profile') // redirect to elsewhere
      return
    }
    if (to.path !== '/profile' && isUserProfileIncomplete(store.state.user.profile)) {
      next('/profile') // profile not complete -> redirect to profile page
      return
    }
    if (to.path !== '/company/profile' && isCompanyProfileIncomplete(store.state.user, store.state.tenant)) {
      next('/company/profile') // company profile not complete + user is admin -> redirect to the company profile page
      return
    }
    next()

  } else { // user is not logged in (store.state.authenticatedUser === false)
    if (to.meta.authRequired || to.meta.adminRequired || to.meta.pfxAdminRequired) { // and route requires login
      next('/sign-in-required') // redirect to elsewhere
      return
    }
    next() // free access page, fine to continue
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js